// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.bg-slate-300 {
  background-color: #cbd5e1;
}

.h-1 {
  height: 90vh;
}

.h-2 {
  height: 20vh;
}

.text-center {
  text-align: center;
}

.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}

.font-bold {
  font-weight: 700;
}

.max-w-sm {
  max-width: 30rem;
}

.mx-auto {
  margin-left: auto;
  margin-right: auto;
}

.mt-5 {
  margin-top: 1.25rem;
}

.mb-5 {
  margin-bottom: 1.25rem;
}

.block {
  display: block;
}

.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.font-medium {
  font-weight: 500;
}

.text-gray-900 {
  color: #d2cad0;
}

.bg-gray-50 {
  background-color: #f9fafb;
}

.border {
  border-width: 1px;
}

.border-gray-300 {
  border-color: #d1d5db;
}

.text-gray-900 {
  color: #ecf0f4;
}

.rounded-lg {
  border-radius: 0.5rem;
}

.focus\\:ring-blue-500:focus {
  box-shadow: 0 0 0 3px #3b82f6;
}

.focus\\:border-blue-500:focus {
  border-color: #3b82f6;
}

.w-full {
  width: 100%;
}

.p-2\\.5 {
  padding: 0.625rem;
}

.dark\\:bg-gray-700 {
  background-color: #757b85;
}

.dark\\:border-gray-600 {
  border-color: #4b5563;
}

.dark\\:placeholder-gray-400 {
  color: #9ca3af;
}

.dark\\:text-white {
  color: #ffffff;
}

.dark\\:focus\\:ring-blue-500:focus {
  box-shadow: 0 0 0 3px #3b82f6;
}

.dark\\:focus\\:border-blue-500:focus {
  border-color: #3b82f6;
}

.text-white {
  color: #ffffff;
}

.bg-blue-700 {
  background-color: #1d4ed8;
}

.hover\\:bg-blue-800:hover {
  background-color: #1e40af;
}

.focus\\:ring-4:focus {
  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.5);
}

.focus\\:outline-none:focus {
  outline: 0;
}

.focus\\:ring-blue-300:focus {
  box-shadow: 0 0 0 4px rgba(147, 197, 253, 0.5);
}

.font-medium {
  font-weight: 500;
}

.rounded-lg {
  border-radius: 0.5rem;
}

.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.w-full {
  width: 100%;
}

.sm\\:w-auto {
  width: auto;
}

.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}

.py-2\\.5 {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}

.text-center {
  text-align: center;
}

.dark\\:bg-blue-600 {
  background-color: #2563eb;
}

.dark\\:hover\\:bg-blue-700:hover {
  background-color: #1e3a8a;
}

.dark\\:focus\\:ring-blue-800:focus {
  box-shadow: 0 0 0 4px #1e40af;
}
`, "",{"version":3,"sources":["webpack://./src/Components/admin/pages/Grievance/createticket.css"],"names":[],"mappings":";AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;AAC/B","sourcesContent":["\r\n.bg-slate-300 {\r\n  background-color: #cbd5e1;\r\n}\r\n\r\n.h-1 {\r\n  height: 90vh;\r\n}\r\n\r\n.h-2 {\r\n  height: 20vh;\r\n}\r\n\r\n.text-center {\r\n  text-align: center;\r\n}\r\n\r\n.text-3xl {\r\n  font-size: 1.875rem;\r\n  line-height: 2.25rem;\r\n}\r\n\r\n.font-bold {\r\n  font-weight: 700;\r\n}\r\n\r\n.max-w-sm {\r\n  max-width: 30rem;\r\n}\r\n\r\n.mx-auto {\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n}\r\n\r\n.mt-5 {\r\n  margin-top: 1.25rem;\r\n}\r\n\r\n.mb-5 {\r\n  margin-bottom: 1.25rem;\r\n}\r\n\r\n.block {\r\n  display: block;\r\n}\r\n\r\n.text-sm {\r\n  font-size: 0.875rem;\r\n  line-height: 1.25rem;\r\n}\r\n\r\n.font-medium {\r\n  font-weight: 500;\r\n}\r\n\r\n.text-gray-900 {\r\n  color: #d2cad0;\r\n}\r\n\r\n.bg-gray-50 {\r\n  background-color: #f9fafb;\r\n}\r\n\r\n.border {\r\n  border-width: 1px;\r\n}\r\n\r\n.border-gray-300 {\r\n  border-color: #d1d5db;\r\n}\r\n\r\n.text-gray-900 {\r\n  color: #ecf0f4;\r\n}\r\n\r\n.rounded-lg {\r\n  border-radius: 0.5rem;\r\n}\r\n\r\n.focus\\:ring-blue-500:focus {\r\n  box-shadow: 0 0 0 3px #3b82f6;\r\n}\r\n\r\n.focus\\:border-blue-500:focus {\r\n  border-color: #3b82f6;\r\n}\r\n\r\n.w-full {\r\n  width: 100%;\r\n}\r\n\r\n.p-2\\.5 {\r\n  padding: 0.625rem;\r\n}\r\n\r\n.dark\\:bg-gray-700 {\r\n  background-color: #757b85;\r\n}\r\n\r\n.dark\\:border-gray-600 {\r\n  border-color: #4b5563;\r\n}\r\n\r\n.dark\\:placeholder-gray-400 {\r\n  color: #9ca3af;\r\n}\r\n\r\n.dark\\:text-white {\r\n  color: #ffffff;\r\n}\r\n\r\n.dark\\:focus\\:ring-blue-500:focus {\r\n  box-shadow: 0 0 0 3px #3b82f6;\r\n}\r\n\r\n.dark\\:focus\\:border-blue-500:focus {\r\n  border-color: #3b82f6;\r\n}\r\n\r\n.text-white {\r\n  color: #ffffff;\r\n}\r\n\r\n.bg-blue-700 {\r\n  background-color: #1d4ed8;\r\n}\r\n\r\n.hover\\:bg-blue-800:hover {\r\n  background-color: #1e40af;\r\n}\r\n\r\n.focus\\:ring-4:focus {\r\n  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.5);\r\n}\r\n\r\n.focus\\:outline-none:focus {\r\n  outline: 0;\r\n}\r\n\r\n.focus\\:ring-blue-300:focus {\r\n  box-shadow: 0 0 0 4px rgba(147, 197, 253, 0.5);\r\n}\r\n\r\n.font-medium {\r\n  font-weight: 500;\r\n}\r\n\r\n.rounded-lg {\r\n  border-radius: 0.5rem;\r\n}\r\n\r\n.text-sm {\r\n  font-size: 0.875rem;\r\n  line-height: 1.25rem;\r\n}\r\n\r\n.w-full {\r\n  width: 100%;\r\n}\r\n\r\n.sm\\:w-auto {\r\n  width: auto;\r\n}\r\n\r\n.px-5 {\r\n  padding-left: 1.25rem;\r\n  padding-right: 1.25rem;\r\n}\r\n\r\n.py-2\\.5 {\r\n  padding-top: 0.625rem;\r\n  padding-bottom: 0.625rem;\r\n}\r\n\r\n.text-center {\r\n  text-align: center;\r\n}\r\n\r\n.dark\\:bg-blue-600 {\r\n  background-color: #2563eb;\r\n}\r\n\r\n.dark\\:hover\\:bg-blue-700:hover {\r\n  background-color: #1e3a8a;\r\n}\r\n\r\n.dark\\:focus\\:ring-blue-800:focus {\r\n  box-shadow: 0 0 0 4px #1e40af;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
